import { LazyLoadingSpinner } from "@/components/LazyLoadingSpinner";
import HomePage from "@/pages/home-page";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomePage,
  beforeLoad: async ({ context: { isAuthenticated } }) => {
    if (!isAuthenticated) {
      throw redirect({ to: "/login" });
    }
    return { isAuthenticated };
  },
  pendingComponent: () => <LazyLoadingSpinner />
});
